const moduleFahuo={    
    state: {
        clicked:0,
        fahuolist:[],
        yunfei:''
    },
    getters:{
        fahuoitemnums:(state)=>(goodsid)=>{
            for(let i=0;i<state.fahuolist.length;i++){
                if(goodsid==state.fahuolist[i].id){
                    return state.fahuolist[i].nums
                }
            }
            return 0
        },
        totalfahuonums:(state)=>(clicked)=>{
            if(!clicked) return 0
            let total=0
            for(let i=0;i<state.fahuolist.length;i++){
                total+=state.fahuolist[i].nums
            }
            return total
        }
    },
    mutations: {
        ADD_TO_FAHUO:(state,payload)=>{
            state.clicked++
            let isNew=true
            for(let i=0;i<state.fahuolist.length;i++){
                if(payload.goodsItem.id==state.fahuolist[i].id){
                    state.fahuolist[i].nums+=1
                    isNew=false
                    break
               }
            }
            if(isNew) {
                payload.goodsItem['nums']=1 
                state.fahuolist.push(payload.goodsItem)
            }
        },
        DEL_FROM_FAHUO:(state,payload)=>{
            state.clicked++
            for(let i=0;i<state.fahuolist.length;i++){
                if(payload.goodsItem.id==state.fahuolist[i].id){
                    if(state.fahuolist[i].nums<=1){
                       state.fahuolist.splice(i,1);
                    }else{
                       state.fahuolist[i].nums-=1;
                    } 
               }
            }
        },
        UPDATE_FHNUMS:(state,payload)=>{
            state.clicked++
            let isNew=true
            for(let i=0;i<state.fahuolist.length;i++){
                if(payload.goodsid==state.fahuolist[i].id){
                    state.fahuolist[i].nums=payload.goodsnums
                    isNew=false
                    break;
                }
            }
            if(isNew){
                payload.goodsitem['nums']=payload.goodsnums
                state.fahuolist.push(payload.goodsitem)
            }
        },
        SET_YUNFEI:(state,payload)=>{
            state.yunfei=payload.yunfei
        },
        INIT_FAHUO:(state)=>{
            state.fahuolist=[]
            state.clicked=0
            state.yunfei=''
        }
    }
}

export default moduleFahuo